import React from "react";
import {
    Link
} from "react-router-dom";
import Dropdown from './../../../components/dropdown.js';

import Notification from 'rc-notification';
let notification = null;
Notification.newInstance({
    style: {
        top: '45px',
        right: 0
    }
}, (n) => notification = n);

export default class Subject extends React.Component {
    constructor(props) {
        super(props);
        let user = {};
        if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
            user = JSON.parse(localStorage.user);
        }

        //console.log(props.data.groupid)
        this.state = {
            user: user,
            projectid: props.data.projectid || 0,
            groupid: props.data.groupid || 0,
            data_type: props.data.data_type,
            prototype: props.data.prototype || [],
            subject: props.data.subject || {},
            pathurl: props.data.pathurl,
            uistyle: props.data.uistyle,
            filestyle: {
                doc: 'far fa-file-word',
                docx: 'far fa-file-word',
                ppt: 'far fa-file-powerpoint',
                pptx: 'far fa-file-powerpoint',
                xls: 'far fa-file-excel',
                xlsx: 'far fa-file-excel',
                pdf: 'far fa-file-pdf',
                mp3: 'far fa-file-audio',
                mp4: 'far fa-file-movie',
                png: 'far fa-file-image',
                jpg: 'far fa-file-image',
                jepg: 'far fa-file-image',
                zip: 'far fa-file-zip',
                rar: 'far fa-file-zip',
                file: 'far fa-file-archive'
            },

            ismodal_download: false,
            downloadurl: '',
            download_message: '',
            checked_subjects: [],
            itemprototype: []
        }

    }

    componentDidMount() {
        let prototype = this.props.data.prototype;
        let subject = this.props.data.subject;
        prototype = prototype.length ? prototype.sort() : [];
        let itemprototype = Object.assign([], prototype);

        if (!subject.series.length) {
            itemprototype.map((ip, pix) => {
                itemprototype[pix] = null;
            })
        } else {
            itemprototype.map((ip, pix) => {
                const indexse = subject.series.indexOf(ip);
                if (indexse < 0) {
                    itemprototype[pix] = null;
                }
            })
        }
        subject = this.qcstate(subject);
        this.setState({
            subject: subject,
            prototype: prototype,
            itemprototype: itemprototype
        })

    }

    componentWillReceiveProps(nextProps) {
        let prototype = nextProps.data.prototype;
        let subject = nextProps.data.subject;
        prototype = prototype.length ? prototype.sort() : [];
        let itemprototype = Object.assign([], prototype);
        //console.log(subject)
        if (!subject.series.length) {
            itemprototype.map((ip, pix) => {
                itemprototype[pix] = null;
            })
        } else {
            itemprototype.map((ip, pix) => {
                const indexse = subject.series.indexOf(ip);
                if (indexse < 0) {
                    itemprototype[pix] = null;
                }
            })
        }

        subject = this.qcstate(subject);
        this.setState({
            projectid: nextProps.data.projectid || 0,
            groupid: nextProps.data.groupid || 0,
            pathurl: nextProps.data.pathurl,
            subject: subject,
            data_type: nextProps.data.data_type,
            uistyle: nextProps.data.uistyle,
            prototype: prototype,
            itemprototype: itemprototype
        })
    }

    qcstate(subject) {
        let linktitle = '';
        if (typeof(subject.head) !== 'undefined' && subject.head !== false && subject.head.length) {
            subject.head.map((t, i) => {
                if (t.files.length) {
                    t.files.map((file, n) => {
                        if (file.input_patientid) {
                            linktitle += file.input_patientid + ' ';
                        }

                    });
                }
            })
        }
        subject.linktitle = linktitle;
        return subject;
    }

    componentWillUnmount() {
        this.setState({
            subject: [],
            data_type: '',
            prototype: [],
            itemprototype: []
        })
    }


    notify(message) {
        notification.notice({
            content: <span>{message}</span>,
            duration: 4,
            style: {
                'bottom': 0,
                'right': 0
            }
        });
    }

    trim(str) {
        return str.replace(/(^\s*)|(\s*$)/g, "");
    }

    render() {
        const me = this;
        let {
            user,
            data_type,
            prototype,
            subject,
            projectid,
            groupid,
            pathurl,
            itemprototype,
            uistyle
        } = me.state;

        return (
            <tr>
                <td>
                    <span className="custom-control custom-checkbox d-inline-block text-secondary ">
                        <input type="checkbox" className="custom-control-input" id={'subject_' + subject.attribute_id + '_' + subject.id} checked={subject.checked} name={'subject_' + subject.attribute_id + '_' + subject.id} onClick={() => me.props.checksubject(subject)} />
                        <label className="custom-control-label subjectname" htmlFor={'subject_' + subject.attribute_id + '_' + subject.id}>{subject.subject_name}</label>
                    </span>

                    {data_type === 'archive' &&
                        <Link to={`/console/archive_files/${projectid}/${subject.id}/${data_type}/?to=${pathurl}`} className="cursor d-inline-block" title="点击查看详情 Show Detail">
                            <small className="mr-1"> {subject.subject_gender === 0 || subject.subject_gender === '0' ? '男' : '女'}
                            </small>
                            <small className="mr-1">{subject.subject_age} 详情</small>
                            <i className="fa fa-chevron-right"></i>
                        </Link>
                    }
                    {
                        data_type !== 'archive' &&
                        <Link to={`/console/subject_files/${projectid}/${subject.id}/0/?to=${pathurl}`} className="cursor d-inline-block"  title="点击查看详情 Show Detail">
                            <small className="mr-1"> {subject.subject_gender === 0 || subject.subject_gender === '0' ? '男' : '女'}
                            </small>
                            <small className="mr-1">{subject.subject_age} 详情</small>
                            <i className="fa fa-chevron-right"></i>
                        </Link>
                    }

                </td>
                {uistyle.is_subjectuid && <td>{subject.subject_uid}</td>}
                <td><i><small>{subject.date_created}</small></i></td>
                <td> {    typeof(subject.subject_modality) !== 'undefined' && subject.subject_modality.length > 0 && subject.subject_modality.map((m, i) => {
                        let mtext = '';
                        if(m.modality!=='archive' && uistyle.is_qcstate ){
                            switch (m.qc_state) {
                                case '1':
                                    mtext = '检测通过';
                                    break;
                                case '2':
                                    mtext= '检测不通过';
                                    break;
                                default:
                                    mtext = '未检测';
                                    break;
                            }
                        }
                        return <span className="mr-2 mb-1 " key={i}><Link to={`/console/subject_files/${projectid}/${subject.id}/${m.modality}/?to=${pathurl}`} className="badge badge-success text-light" key={i}>{m.modality=='archive' ? '' : m.modality}</Link>  <i className="text-muted small">{mtext}</i> </span>
                            })
                            }
                </td>

                <td>
                    {    typeof(subject.tags) !== 'undefined' && subject.tags.length > 0 && subject.tags.map((m, i) => {

                        return <span className="mr-2 mb-1 badge badge-info" key={i}>{m.name}</span>
                    })
                }
                </td>

                <td className="text-right">
                    <Dropdown direction="dropleft">
                        <div><i className="fa fa-bars"></i> <i className="fa fa-angle-down"></i></div>
                        <div>
                            <div className="dropdown-header">操作菜单</div>
                            <div className="dropdown-item cursor" onClick={() => { this.props.modalSubject(subject,'editsubject') }}><i className="fa fa-edit"></i> 修改信息</div>
                            {
                                data_type !== 'archive' && 
                                <div className="dropdown-item cursor" onClick={() => { this.props.modalDownload(subject, 'nifti') }}><i className="fa fa-download"></i> 下载数据</div>
                            }
                            {
                                data_type !== 'archive' && user.level < 2 &&
                                <div className="dropdown-item cursor" onClick={() => { this.props.modalDownload(subject, 'dicom') }}><i className="fa fa-download"></i> 下载数据 - DICOM</div>
                            }
                            
                            {
                                data_type === 'archive' &&
                                <div className="dropdown-item cursor" onClick={() => { this.props.modalDownload(subject, 'otherfile') }}><i className="fa fa-download"></i> 下载数据</div>
                            }
                            <div className="dropdown-divider"></div>

                                <div className="dropdown-item cursor" onClick={() => { this.props.modalSubject(subject,'tagsubject') }}><i className="fa fa-tags"></i> 添加标签</div>

                            <div className="dropdown-divider"></div>
                            <div className="dropdown-item cursor text-danger" onClick={() => { this.props.removeSubject(subject) }}>删除</div>
                        </div>
                    </Dropdown>
                </td>
            </tr>
        )
    }
}


// WEBPACK FOOTER //
// ./src/apps/console/uncategorized/subject.js